import React from 'react';
import { TaskTableSummaryLayout, TaskTableSummaryText } from './TaskTableSummary.styles';

const TaskTableSummary = ({ total, textSize = '18px' }: { total: number; textSize?: string }) => {
  return (
    <TaskTableSummaryLayout role="region">
      <TaskTableSummaryText textSize={textSize}>
        {total} {total === 1 ? 'Task' : 'Tasks'}
      </TaskTableSummaryText>
    </TaskTableSummaryLayout>
  );
};

export default TaskTableSummary;
